export enum RangeColorVariant {
    BASE = "base",
    GREEN = "green",
    LAVENDER = "lavender",
    RED_YELLOW_GREEN = "redYellowGreen"
}
export enum RangeColorVariant {
    BASE = "base",
    GREEN = "green",
    LAVENDER = "lavender",
    RED_YELLOW_GREEN = "redYellowGreen"
}
